// ----------------------------------------------------------------------

/**
 * Transient overlays (menus, popovers) mount and unmount their whole content on every
 * open/close. When a page translator has rewritten the text nodes in that content, React's
 * unmount hits nodes that were reparented behind its back and throws
 * "NotFoundError: Failed to execute 'removeChild' on 'Node'", taking the page down.
 *
 * Opting the overlay surfaces out of translation keeps that DOM React's alone to manage;
 * the rest of the page still translates. Tooltips get the same treatment in Tooltip.js.
 */
export default function Overlay() {
  return {
    MuiPopover: {
      defaultProps: {
        slotProps: { paper: { translate: "no" } },
      },
    },
    MuiMenu: {
      defaultProps: {
        slotProps: { paper: { translate: "no" } },
      },
    },
  };
}
